import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = {
    key: 0,
    class: "d-flex align-items-center mt-3 mt-lg-0"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_v_select = _resolveComponent("v-select");
    const _component_ReferralLoyaltyConfig = _resolveComponent("ReferralLoyaltyConfig");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('sidebar.loyalty')
        }, null, 8, ["PageTitle"]),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[1] || (_cache[1] = _createElementVNode("label", {
                            class: "form-label text-muted small mb-0 me-2",
                            style: { "white-space": "nowrap" }
                        }, "Restaurant :", -1)),
                        _createVNode(_component_v_select, {
                            modelValue: _ctx.selectedRestaurant,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                            options: _ctx.restaurantOptions,
                            label: "name",
                            reduce: (restaurant) => restaurant.id,
                            placeholder: "Sélectionner un restaurant",
                            class: "restaurant-select",
                            style: { "min-width": "250px" }
                        }, null, 8, ["modelValue", "options", "reduce"])
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        _createVNode(_component_ReferralLoyaltyConfig, { restaurantId: _ctx.selectedRestaurant }, null, 8, ["restaurantId"])
    ], 64));
}
